export const isValidUrl = (url: string): boolean => {
  const pattern = /^(?:https:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;%=.]+$/i
  const newUrl = url.replace(/^(http(s)?:\/\/)/i, '')
  return pattern.test(newUrl)
}
